// utils/sessionCache.ts

import { Session } from 'next-auth';
import { getSession } from 'next-auth/react';

let sessionCache: Session | null = null;
let lastFetched = 0;
let inFlight: Promise<Session | null> | null = null;

const CACHE_DURATION_MS = 30 * 1000; // 30 seconds

/**
 * Get the cached session or fetch it if expired.
 * @param forceRefresh If true, bypasses cache and fetches new session.
 */
export const getCachedSession = async (forceRefresh = false) => {
    const now = Date.now();

    if (!forceRefresh && sessionCache && now - lastFetched < CACHE_DURATION_MS) {
        return sessionCache;
    }

    if (!forceRefresh && inFlight) {
        return inFlight;
    }

    inFlight = getSession().then(session => {
        sessionCache = session;
        lastFetched = Date.now();
        inFlight = null; // Reset inFlight after fetching
        return sessionCache;
    });

    return inFlight;
};
